import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sortingUp",
  "use": "sortingUp-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8 5\" id=\"sortingUp\">\n<path d=\"M4,0C3.8,0,3.7,0.1,3.7,0.1S1.3,1.8,0.1,3.4C0,3.6,0,3.8,0,3.9c0.1,0.2,0.3,0.3,0.4,0.3h7.1c0.2,0,0.4-0.1,0.4-0.3\n\tC8,3.8,8,3.6,7.9,3.4C6.7,1.8,4.3,0.1,4.3,0.1S4.2,0,4,0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol